import { render } from "./TicketsDoing.vue?vue&type=template&id=55a691f7&scoped=true&ts=true"
import script from "./TicketsDoing.vue?vue&type=script&lang=ts"
export * from "./TicketsDoing.vue?vue&type=script&lang=ts"

import "./TicketsDoing.vue?vue&type=style&index=0&id=55a691f7&scoped=true&lang=less"

import exportComponent from "/home/gitlab-runner/builds/LUZizzTB/0/unicorn/frontend/unicorn-fe-support/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55a691f7"]])

export default __exports__